import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { OptionsRulesDocument } from 'src/app/shared/models/OptionsRulesDocument';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';

@Component({
  selector: 'app-option-rules-hdr',
  templateUrl: './option-rules-hdr.component.html',
  styleUrls: ['./option-rules-hdr.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class OptionRulesHdrComponent implements OnInit {

  findOptInput:string;
  lstOptionRules: OptionsRulesDocument[];
  selectedOptionRule: OptionsRulesDocument;

  optionDialog:boolean;
  optionRule:OptionsRulesDocument;
  submitted: boolean;
  userCanEdit: boolean;
  textUser: string;
  userId: string;

  optionRuleDate:Date;

  loading = false;

  uploadedFiles: any[] = [];
  fileRule: File;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) {
      this.route.queryParams.subscribe(params => {
        let option = params['opt'];
        this.userId = params['userId'];
        if(option){
          this.checkUserCanEdit();
          this.findOptInput = option;
          this.findOption();

        }else{
          this.messageService.add({severity:'warn', summary: 'Busqueda Opción', detail: 'No hay opción que buscar', life: 3000});
        }
       
      });
    }

  ngOnInit(): void {
  }

  findOption(){
    if(typeof this.findOptInput!='undefined' && this.findOptInput){
      this.getOptions(this.findOptInput);
    }else{
      this.messageService.add({severity:'warn', summary: 'Buscar Opción', detail: 'Favor de llenar información', life: 3000});
    }
  }

  openNewOption() {
    this.optionRule ={}; //new OptionsRulesDocument;
    this.submitted = false;
    this.optionDialog = true;
  }

  hideDialog() {
    this.optionDialog = false;
    this.submitted = false;
  }

  createOptionRule(){
    this.submitted = true;
    

    if(this.optionRule.summary && this.optionRuleDate && this.optionRule.fullDescription){
      this.loading = true;
      this.optionRule["key"] = {optionId : this.findOptInput};
      this.optionRule["startingDate"] = this.tovpilUtils.dateToTovpilDate(this.optionRuleDate);

      this.apiService.createOptionsRules(this.optionRule).then(
        rulesOption => {
          this.optionDialog = false;
          this.optionRule = {};
          this.optionRuleDate = null;
          this.loading = false;

          //*Verificamos si se agrego archivo */
          if(this.fileRule){
            this.saveFileRule(rulesOption);
          }

          this.messageService.add({severity:'success', summary: 'Crear Opción', detail: 'Se creo opción correctamente', life: 3000});
          this.getOptions(this.findOptInput);
      });
    }else{
      this.messageService.add({severity:'error', summary: 'Crear Opción', detail: 'Favor de llenar información requerida', life: 3000});
    }

  }

  getOptions(search){
    this.apiService.getOptionsRulesByOption({optionId:search}).then(
      rulesOption => {
        this.lstOptionRules = rulesOption;
    });
  }

  editOption(optionRule: OptionsRulesDocument) {
    this.optionRule = {...optionRule};
    this.optionDialog = true;
  }

  onUploadEvidenceOption(event){
    this.messageService.add({severity: 'info', summary: 'Evidencia Archivo', detail: 'Se subio evidencia correctamente'});
  }

  deleteOptionRule(optionRule: OptionsRulesDocument) {

    this.confirmationService.confirm({
        message:  '¿ Esta seguro de eliminar la opción' + optionRule.key.sequence + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        acceptButtonStyleClass: "p-button-danger",
        rejectButtonStyleClass: "p-button-info",
        accept: () => {
          this.apiService.deleteOptionsRules(optionRule).then(
            rulesOption => {
              this.getOptions(this.findOptInput);

              this.messageService.add({severity:'success', summary: 'Eliminar Opción', detail: 'Se elimino opción correctamente', life: 3000});

          });

        }
    });
  }

  onShowModalOption(){
    this.optionRuleDate = this.tovpilUtils.convertStringToDate(this.optionRule.startingDate);
    const parts = [
      new Blob([''], {
      }),
      ' Same way as you do with blob',
      new Uint16Array([33])
    ];
    let fileSelected: File =  new File(parts,this.optionRule.eviedencefileName);
    this.uploadedFiles.push(fileSelected);

  }

  uploadEvent(event) {
    this.fileRule = event.currentFiles[0];
  }

  saveFileRule(optionRules: OptionsRulesDocument){
    if(this.fileRule){
      const reader = new FileReader();
      reader.readAsDataURL(this.fileRule);
      reader.onload = () => {
        let array = (<string>reader.result).split(",");
        this.apiService.saveFileSantoApp({
          "nameFile": optionRules.key.optionId +"_"+ optionRules.key.sequence +"_"+this.fileRule.name,
          "base64File":array[1],
          "folderId":"RULES"
        }).then(
          data => {
            optionRules.eviedencefileName = optionRules.key.optionId +"_"+ optionRules.key.sequence +"_"+this.fileRule.name,
            /**Actualizamos el nombre del archivo */
            this.apiService.updateOptionsRules(optionRules).then(
              rulesOption => {
               this.getOptions(this.findOptInput);
            });
            this.messageService.add({severity:'success', summary: 'Crear Opción', detail: 'Se guardo archivo correctamente', life: 3000});

        })
      };
    }
  }

  downloadEvidence(option: OptionsRulesDocument){
    this.apiService.getFileSantoApp({
        "nameFile": option.eviedencefileName,
        "folderId":"RULES"    
    }).then(
      data => {
        const source = `data:application/octet-stream;base64,${data.base64File}`;
         const link = document.createElement("a");
         link.href = source;
         link.download = `${option.eviedencefileName}`
         link.click();
    })
  }
checkUserCanEdit(){
    this.userCanEdit=false;
    let cat: CategoryLan[]; 
    this.apiService.getCategoryLang({
      "fieldId": "usersDocum"
    }).then(
      data => {
        cat = data;
        cat.forEach((element) => {
          if(element.descrip.trim()==this.userId){
            this.userCanEdit=true;
            this.textUser='(ESTE USUARIO PUEDE EDITAR AYUDAS)';
          }
        });      
      })
  }
  goBack(){
    this.router.navigate(['assist/options'],{ queryParams: { optionId: this.findOptInput,userId:this.userId } });
  }
}
